(function () {
  'use strict';
  class ClownReviewReader extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.viewport = this.querySelector('[data-review-viewport]');
      this.cards = Array.from(this.querySelectorAll('.clown-meta-reviews__card'));
      if (!this.viewport || !this.cards.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.position = this.querySelector('[data-review-position]');
      this.querySelector('[data-review-navigation]').hidden = false;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.update(), 120);
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.viewport);
      this.update();
    }
    metrics() {
      const gap = parseFloat(getComputedStyle(this.viewport.firstElementChild).gap) || 0;
      const step = this.cards[0].getBoundingClientRect().width + gap;
      return { step, count: Math.max(1, Math.floor((this.viewport.clientWidth + gap + 1) / step)) };
    }
    move(direction) {
      const { step, count } = this.metrics();
      this.viewport.scrollBy({
        left: direction * step * count,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    update() {
      const { step, count } = this.metrics();
      if (!step) return;
      const first = Math.round(this.viewport.scrollLeft / step) + 1;
      const last = Math.min(first + count - 1, this.cards.length);
      this.previous.disabled = this.viewport.scrollLeft <= 1;
      this.next.disabled = this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 1;
      this.position.textContent = (first === last ? first : first + '–' + last) + ' / ' + this.cards.length;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resize?.disconnect();
      clearTimeout(this.timer);
    }
  }
  if (!customElements.get('clown-review-reader')) { customElements.define('clown-review-reader', ClownReviewReader); }
}());
